import { Form, Select, Tooltip } from "antd";
import { FormItemProps } from "antd/es/form";
import { SelectProps } from "antd/es/select";
import style from "./FormItem.module.scss";

type FormItemPropsExpanded<T> = FormItemProps<T> & Omit<SelectProps, "name">;

interface SelectFormItemProps<T> extends FormItemPropsExpanded<T> {
  disabledTooltip?: string;
  testId?: string;
  textOnly?: boolean;
}

export const SelectFormItem = <T extends object>({
  id,
  name,
  label,
  rules,
  testId,
  disabled,
  children,
  className,
  textOnly,
  value,
  disabledTooltip,
  ...props
}: SelectFormItemProps<T>) => {
  return (
    <Tooltip title={disabled ? disabledTooltip : ""} placement="topRight">
      <Form.Item
        id={id}
        name={name}
        label={label}
        rules={rules}
        data-testid={testId}
        className={`${style.formItem} ${style.fontSize} ${className} truncate`}
      >
        <Select
          disabled={disabled}
          optionFilterProp="label"
          className={`${style.fontSize} ${style.formItemInput}`}
          {...props}
        >
          {children}
        </Select>
      </Form.Item>
    </Tooltip>
  );
};

export default SelectFormItem;
